import React from "react";
import { useTranslation } from "react-i18next";

import IconTile from "../../IconTile";
import TextLink from "../../../TextLink";

import style from "./styles.module.scss";

const keyI18n = "translations.regulatoryLaws.laws";

const laws = [
  { number: "6", labelKey: `${keyI18n}.lc6` },
  { number: "9", labelKey: `${keyI18n}.lc9` },
  { number: "10", labelKey: `${keyI18n}.lc10` },
  { number: "16", labelKey: `${keyI18n}.lc16` },
  { number: "71", labelKey: `${keyI18n}.lc71` },
  { number: "122", labelKey: `${keyI18n}.lc122` },
  { number: "151", labelKey: `${keyI18n}.lc151` },
  { number: "185", labelKey: `${keyI18n}.lc185` },
  { number: "252", labelKey: `${keyI18n}.lc252` },
  { number: "253", labelKey: `${keyI18n}.lc253` },
  { number: "274", labelKey: `${keyI18n}.lc274` },
  { number: "315", labelKey: `${keyI18n}.lc315` },
];

export default function LawList() {
  const { t } = useTranslation();

  return (
    <ul className={style.list}>
      {laws.map(({ number, labelKey }) => (
        <li className={style.item} key={number}>
          <IconTile filled icon="picture_as_pdf" size="small" tone="tertiary" />
          <TextLink
            className={`pgm-title-medium ${style.link}`}
            link={`/leis_complementares/lei_complementar_${number}.pdf`}
            target="_blank"
            text={t(labelKey)}
          />
        </li>
      ))}
    </ul>
  );
}
